import React from 'react';

const Amex = (props: object) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="42"
      height="26"
      viewBox="0 0 42 26"
      fill="none"
      {...props}
    >
      <rect width="42" height="26" rx="3" fill="#006FCF" />
      <path
        d="M8.5 18H6L9.5 8H12.5L16 18H13.5L12.8 16H9.2L8.5 18ZM11 10.5L9.8 14H12.2L11 10.5Z"
        fill="white"
      />
      <path
        d="M17 18V8H21L22.5 14L24 8H28V18H26V11L24 18H21L19 11V18H17Z"
        fill="white"
      />
      <path d="M29 18V8H36V10H31V12H35.5V14H31V16H36V18H29Z" fill="white" />
      <path
        d="M6 8L4 13L2 8H0V18H2V11L4 16H4L6 11V18H8V8H6Z"
        fill="white"
        fillOpacity="0"
      />
    </svg>
  );
};

export default Amex;
